import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function reasonCodeReducer(state = { ...initialState?.amexDisputeReasonCode }, action) {
  switch (action.type) {
    case types.SET_AMEX_DISPUTE_REASON_CODE:
      return {
        ...state,
        amexDisputeReasonCode: action.amexDisputeReasonCode,
      };
    default:
      return state;
  }
}
